<template>
  <div class="view active">
    <header class="view-header">
      <h1>Weekly Report</h1>
      <p class="subtitle">Astrological market outlook for the week ahead.</p>
    </header>

    <div class="report-section blurred-section">
      <div class="blur-overlay">
        <div class="lock-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <h2>Weekly Report</h2>
        <p>Comprehensive weekly analysis covering all tracked commodities with planetary alignment impacts and trade recommendations.</p>
        <div class="blur-peek">
          <div class="peek-row"><span class="peek-label">Gold</span><span class="peek-value text-success">+2.3% projected</span></div>
          <div class="peek-row"><span class="peek-label">Silver</span><span class="peek-value text-success">+3.8% projected</span></div>
          <div class="peek-row"><span class="peek-label">Copper</span><span class="peek-value text-warning">+0.5% projected</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.report-section {
  position: relative;
  min-height: 340px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  overflow: hidden;
}

.blurred-section {
  filter: blur(0);
}

.blur-overlay {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 2rem;
  min-height: 340px;
  /* The actual content behind — we blur a fake background */
  background: linear-gradient(135deg, rgba(248, 244, 235, 0.92), rgba(255, 255, 255, 0.92));
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.blur-overlay::before {
  content: '';
  position: absolute;
  inset: 0;
  /* Simulated blurred report content underneath */
  background:
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 22px,
      rgba(0,0,0,0.04) 22px,
      rgba(0,0,0,0.04) 23px
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 140px,
      rgba(0,0,0,0.03) 140px,
      rgba(0,0,0,0.03) 141px
    );
  filter: blur(4px);
  z-index: -1;
  border-radius: 16px;
}

.lock-icon {
  width: 48px;
  height: 48px;
  color: var(--text-dim);
  margin-bottom: 1rem;
  opacity: 0.7;
}

.lock-icon svg {
  width: 100%;
  height: 100%;
}

.blur-overlay h2 {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.blur-overlay p {
  font-size: 0.88rem;
  color: var(--text-secondary);
  max-width: 420px;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.blur-peek {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: rgba(255,255,255,0.7);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 0.85rem 1.5rem;
  filter: blur(3px);
  user-select: none;
}

.peek-row {
  display: flex;
  gap: 1rem;
  font-size: 0.85rem;
  font-family: var(--font-mono);
}

.peek-label {
  color: var(--text-primary);
  font-weight: 600;
  min-width: 70px;
}

.peek-value {
  font-weight: 500;
}

.text-success { color: var(--bullish); }
.text-warning { color: var(--warning); }
.text-danger { color: var(--danger); }
</style>
